import { obterConfiguracaoBase, obterConfiguracaoDeletar } from "./configuracao-tabela-base";

export function obterConfiguracaoArquivos() {
    const base = obterConfiguracaoBase();

    return {
        ...base,
        actions: {
          ...base.actions,
          add: false,
          edit: false,
          delete: true,
          custom: [
            {
              name: 'Download file',
              title: '<i class="btn btn-xs icon-btn btn-primary"><span class="fas fa-download"></span></i>'
            }
          ]
        },
        delete: obterConfiguracaoDeletar(),
        columns: {}
    };
}
